import BatchEvents from './BatchEvents';

export default BatchEvents;
